import React from 'react';
import WebsiteDemoViewerV2 from './WebsiteDemoViewerV2';

function App() {
  return <WebsiteDemoViewerV2 />;
}

export default App;
